import { useEffect } from "react";
import AOS from "aos";
import "aos/dist/aos.css";

const Property = () => {
  useEffect(() => {
    AOS.refresh();
  });

  useEffect(() => {
    AOS.init({
      duration: 1000,
      offset: 200,
    });
  }, []);

  return (
    <>
      <div className="property-container">
        <div class="debt-consolidation-section">
          <div class="debt-consolidation-left" data-aos="fade-right">
            <h1 class="section-title highlight-gradient">MORTGAGES</h1>
            <p class="section-description ">
              Fed up with the hassle and unpredictability of traditional
              mortgage loans? A private loan gives you the flexibility and
              control to select a loan that meets your needs, not the bank's.
            </p>
            <p class="section-description">
              Stop letting traditional mortgages hold you back. Apply today to
              see if you qualify for your 1st, 2nd, or 3rd mortgage.
            </p>
          </div>
          <div class="debt-consolidation-right" data-aos="fade-left">
            <div class="feature-point">
              <h2 class="feature-title">Faster approval and closing</h2>
              <p class="feature-text">
                Private loans often have fewer requirements than traditional
                mortgages, allowing you to get approved and close on your loan
                more quickly.
              </p>
            </div>

            <div class="feature-point">
              <h2 class="feature-title">Remove credit score requirements</h2>
              <p class="feature-text">
                If you've been denied a traditional mortgage or have a lower
                credit score, you might still qualify for a private loan.
              </p>
            </div>

            <div class="feature-point">
              <h2 class="feature-title">More flexible terms</h2>
              <p class="feature-text">
                Private loans offer greater flexibility in loan terms, allowing
                you to select an option that suits your budget and lifestyle,
                rather than being restricted to the terms set by a bank.
              </p>
            </div>
            <div class="feature-point">
              <h2 class="feature-title">No pre-payment penalties</h2>
              <p class="feature-text">
                A private loan allows you to pay off your mortgage early without
                penalties, potentially saving you thousands of dollars in
                interest throughout the life of your loan.
              </p>
            </div>
          </div>
        </div>
        <div class="debt-consolidation-section">
          <div class="debt-consolidation-left" data-aos="fade-right">
            <h1 class="section-title highlight-gradient">RENOVATIONS</h1>
            <p class="section-description">
              If you're thinking about renovating your home or investment
              property, a private loan can be an excellent way to fund your next
              project. With competitive rates, flexibility, fast approval, and
              potential tax benefits, a private loan might be the perfect
              solution to fit your budget and timeline. Apply today to find out
              if a private loan is right for you.
            </p>
          </div>
          <div class="debt-consolidation-right" data-aos="fade-left">
            <div class="feature-point">
              <h2 class="feature-title">Flexibility</h2>
              <p class="feature-text">
                Access a range of loan options and terms, giving you the ability
                to tailor your loan to meet your unique needs and budget.
              </p>
            </div>

            <div class="feature-point">
              <h2 class="feature-title">Faster approval</h2>
              <p class="feature-text">
                In a hurry? With 24-hour approval, our lenders are quicker than
                traditional banks, so you can get started even on short notice.
              </p>
            </div>

            <div class="feature-point">
              <h2 class="feature-title">No income or credit check</h2>
              <p class="feature-text">
                Our application process doesn’t require income or credit checks,
                making it easier for you to secure the funding you need.
              </p>
            </div>
            <div class="feature-point">
              <h2 class="feature-title">Personal or resale value</h2>
              <p class="feature-text">
                Renovations can greatly enhance the value of your property or
                boost your return on investment if you're planning to sell.
              </p>
            </div>
          </div>
        </div>
        <div class="debt-consolidation-section">
          <div class="debt-consolidation-left" data-aos="fade-right">
            <h1 class="section-title highlight-gradient">INVESTMENTS</h1>
            <p class="section-description ">
              Looking to invest in a new opportunity but lacking the necessary
              liquidity? A private loan could provide the financial support you
              need to reach your goals.
            </p>
            <p class="section-description">
              A private loan gives you access to the funds you need to invest in
              your desired opportunity without navigating the traditional
              banking system.
            </p>
          </div>
          <div class="debt-consolidation-right" data-aos="fade-left">
            <div class="feature-point">
              <h2 class="feature-title">Fast approval</h2>
              <p class="feature-text">
                Get approved for a loan quickly with minimal paperwork. Apply
                today and receive approval in as little as 24 hours.
              </p>
            </div>

            <div class="feature-point">
              <h2 class="feature-title">Unlimited choice</h2>
              <p class="feature-text">
                Access funds that can be used for any purpose, including stocks,
                options contracts, real estate, or starting a new business.
              </p>
            </div>

            <div class="feature-point">
              <h2 class="feature-title">Flexibility</h2>
              <p class="feature-text">
                Enjoy the freedom to repay your loan on your own terms, without
                any prepayment penalties.
              </p>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Property;
